module.exports = {
  blogPostDir: 'sample-posts', // The name of directory that contains your posts.
  siteTitle: 'ProYuga', // Site title.
  siteTitleAlt: 'ProYuga', // Alternative site title for SEO.
  siteLogo: 'https://proyuga.tech/assets/images/ProyugaLogo/Proyuga-Img.png',
  socialSiteSharingImage:
    'https://ib.cricket/assets/images/SocialImages/ibcMediaLarge.png', // Logo used for SEO and manifest.
  siteUrl: 'https://proyuga.tech/', // Domain of your website without pathPrefix.
  siteDescription:
    'Developing transformative products in Virtual, Augmented and Mixed reality. We develop our own products, help others to develop their own products and offer development services to organizations. Our first product is iB Cricket, a new format of cricket, a vSport(eSport in Virtual Reality)',
  siteGATrackingID: 'GTM-M2LQ8G4', // Tracking code ID for google analytics.
  copyright: '© 2018 ProYuga. All rights reserved' // Copyright string for the footer of the website and RSS feed.
}
